import React, { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, getMe } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // user states: undefined=loading, null=logged out, object=logged in
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    const cached = localStorage.getItem("auth_user");
    if (!token) {
      setUser(null);
      return;
    }
    // Optimistic: show cached user immediately
    if (cached) {
      try { setUser(JSON.parse(cached)); } catch { /* noop */ }
    }
    // Validate with backend
    getMe()
      .then((u) => {
        setUser(u);
        localStorage.setItem("auth_user", JSON.stringify(u));
      })
      .catch(() => {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { token, user } = await apiLogin(email, password);
    localStorage.setItem("auth_token", token);
    localStorage.setItem("auth_user", JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
